import { Link } from "react-router-dom";
import { ShieldCheck, Flag, Trash2, CreditCard } from "lucide-react";
import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Profiller herkese açık değil",
    text: "Deneyim yalnızca uygulama içinde yaşanır; profilin herkese açık bir web sayfası değildir.",
  },
  {
    icon: Trash2,
    title: "Kontrol sende",
    text: "Hesabını istediğin zaman uygulama içinden silebilirsin.",
    link: { to: "/account-deletion", label: "Hesap Silme" },
  },
  {
    icon: Flag,
    title: "Bildirim mekanizması",
    text: "Uygunsuz davranışları uygulama içinden bildirebilirsin; bildirimler incelenir.",
  },
  {
    icon: CreditCard,
    title: "Şeffaf abonelik",
    text: "Üyeliğini App Store üzerinden yönetir, istediğin zaman iptal edebilirsin.",
  },
];

export default function Trust() {
  return (
    <section data-testid="trust-section" className="py-24 sm:py-32 bg-ivory-alt border-t border-burgundy/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <FadeUp>
            <Eyebrow>Gizlilik &amp; Güven</Eyebrow>
          </FadeUp>
          <h2 className="mt-7 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-ink">
            <MaskedLines
              lines={[
                "Özel hayatın,",
                <em key="em" className="italic text-burgundy">
                  özel kalır.
                </em>,
              ]}
            />
          </h2>
          <FadeUp delay={0.2} className="mt-6 text-base font-light text-ink-soft/90 leading-relaxed max-w-xl">
            Five Star&rsquo;da gizlilik ve güvenlik deneyimin temel parçalarıdır. Hesabını istediğin zaman silebilir,
            uygunsuz davranışları bildirebilir ve üyeliğini App Store üzerinden yönetebilirsin.
          </FadeUp>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((item, i) => (
            <FadeUp key={item.title} delay={i * 0.1}>
              <div
                data-testid={`trust-item-${i}`}
                className="h-full bg-ivory-light border border-burgundy/10 rounded-[6px] p-7 hover:border-burgundy/25 transition-colors duration-300"
              >
                <span className="w-10 h-10 rounded-full border border-gold/50 flex items-center justify-center">
                  <item.icon className="w-[18px] h-[18px] text-burgundy" aria-hidden="true" />
                </span>
                <h3 className="mt-5 font-serif text-xl text-ink">{item.title}</h3>
                <p className="mt-2.5 text-sm font-light text-ink-soft/90 leading-relaxed">{item.text}</p>
                {item.link && (
                  <Link
                    to={item.link.to}
                    data-testid="trust-account-deletion-link"
                    className="mt-4 inline-block text-xs font-semibold tracking-wide text-burgundy border-b border-burgundy/30 hover:border-burgundy pb-0.5 transition-colors"
                  >
                    {item.link.label}
                  </Link>
                )}
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.25} className="mt-10">
          <Link to="/privacy" data-testid="trust-privacy-link" className="link-ghost">
            Gizlilik Politikası&rsquo;nı incele
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
